import React from "react";
import { statusCategories } from "../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import PieChart from "../PieChart";
import type { SelectedScope } from "../../../types/scope";

export const TicketStatus = {
  BACKLOG: { title: "Backlog", fill: "#8DC9F3", sort: 0 },
  SCHEDULED: { title: "Scheduled", fill: "#5565F9", sort: 1 },
  IN_PROGRESS: { title: "In Progress", fill: "#A673F1", sort: 2 },
  DONE: { title: "Done", fill: "#21BC89", sort: 3 },
  REJECTED: { title: "Rejected", fill: "#EC2A3F", sort: 4 },
};

export interface FindingsByTicketStatusProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id: string;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const FindingsByTicketStatus: React.FC<FindingsByTicketStatusProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  setIsReadyToExport,
}) => {
  const filterConfig = {
    filtersjson: filterToExecute,
    scopesjson: scopeToExecute || null,
    // Preserves the original value exactly (`string | undefined`); PieChart's
    // `scopesid` is typed `string | null`, so widen the field type here without
    // coercing the runtime value.
    scopesid: selectedScope?.value?.id as string | null | undefined,
  };
  const chartFilterValue = [
    {
      type: "category",
      key: statusCategories.OPEN,
      id: statusCategories.OPEN,
    },
  ];
  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;
  const chartName = `ticketStatusDashboard-${id}`;

  return (
    <PieChart
      skip={skip}
      categories={TicketStatus}
      groupBy={["ticket.status"]}
      legendTitle={"Ticket status"}
      filtersConfig={filterConfig}
      chartName={chartName}
      chartFilterValue={chartFilterValue}
      actualFilterField={"ticket_status"}
      dataSubject={"Tickets"}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default FindingsByTicketStatus;
